import { ShieldAlertIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { AuthShell } from '@/components/layout/AuthShell'

export function ForbiddenPage() {
  const { t } = useTranslation()

  return (
    <AuthShell>
      <Card>
        <CardHeader>
          <ShieldAlertIcon className="text-muted-foreground mb-1 size-5" aria-hidden />
          <CardTitle>{t('forbidden.title')}</CardTitle>
          <CardDescription>{t('forbidden.description')}</CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild className="w-full">
            <Link to="/">{t('common.backToDashboard')}</Link>
          </Button>
        </CardContent>
      </Card>
    </AuthShell>
  )
}
